import { render, staticRenderFns } from "./VDialogDiff.vue?vue&type=template&id=d1bb9fbe&scoped=true"
import script from "./VDialogDiff.vue?vue&type=script&lang=js"
export * from "./VDialogDiff.vue?vue&type=script&lang=js"
import style0 from "./VDialogDiff.vue?vue&type=style&index=0&id=d1bb9fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bb9fbe",
  null
  
)

export default component.exports